import apiService from '../../apiService'
import Notification from '../../notification'

export default {
  namespaced: true,
  state: {
    services: [],
    fetching: true
  },
  mutations: {
    setServices (state, services) {
      state.services = services
    }
  },
  actions: {
    fetch ({ state, commit }, domain) {
      apiService.getServices()
        .then(response => {
          commit('setServices', response.data)
          window.vue.$emit('servicesLoaded', response.data)
        })
        .catch(() => {
          Notification.notifyError({
            title: 'Ошибка',
            content: 'Не удалось загрузить информацию по подключенным услугам.'
          })
        })
        .finally(() => {
          state.fetching = false
        })
    }
  },
  getters: {
    isConnected: state => service => {
      return state.services.includes(service.toLowerCase())
    }
  }
}
